import { useMutation, useQuery } from '@tanstack/react-query';
import { toast } from 'sonner';
import { queryClient, trpc } from '@/utils/trpc';

export const useGetOrganizationInfo = (options?: { enabled?: boolean }) => {
  return useQuery({
    ...trpc.organizationsRouter.getOrganizationInfo.queryOptions(),
    enabled: options?.enabled ?? true,
  });
};

export const useExportPatientDataCsv = () => {
  return useMutation({
    mutationFn: () =>
      queryClient.fetchQuery(
        trpc.organizationsRouter.exportPatientDataCsv.queryOptions(),
      ),
    onError: () => {
      toast.error('Failed to export patient data. Please try again.');
    },
  });
};
